import OLTileLayer from 'ol/layer/Tile';
import OLTileDebug from 'ol/source/TileDebug';
import { useEffect, useState } from 'react';

const GridDebugLayer = (props) => {
    const { zIndex, map, visible = true, onAdded = () => {} } = props;
    const [addedToMap, setAddedToMap] = useState(false);

    const [lyr] = useState(
        new OLTileLayer({
            source: new OLTileDebug()
        })
    );
    const setOpacity = () => {
        lyr.setOpacity(visible ? 1 : 0);
    };

    useEffect(() => {
        if (!map) return;
        if (addedToMap) return; //ΔVΔVΔ: Only Happens On local and testing, prevents re-adding
        map.addLayer(lyr);
        lyr.setZIndex(zIndex);
        setOpacity();
        setAddedToMap(true);
        onAdded(lyr); //ΔVΔVΔ: run passed in function
        return () => {
            if (map) {
                map.removeLayer(lyr);
                setAddedToMap(false);
            }
        };
    }, [map]);

    return null;
};

export { GridDebugLayer };
